"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const URLs_1 = require("../utility/URLs");
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
function CategoryEditor(props) {
    const [name, setname] = react_1.default.useState(null);
    let { id } = (0, react_router_1.useParams)();
    const [category, setcategory] = react_1.default.useState(null);
    function setup() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchCategory(id); }), setcategory, 'CategoryEditor', true);
        });
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    function submit() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.editCategory(id, name); }), (data) => { alert('category is updated'); setredirect(URLs_1.Routes.categoriesIndex); }, 'CategoryEditor submit', true);
        });
    }
    const [redirect, setredirect] = react_1.default.useState(null);
    if (redirect)
        return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    return (react_1.default.createElement(react_bootstrap_1.Container, null,
        react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.categoryEdit(category === null || category === void 0 ? void 0 : category.id) }, "edit"),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
            react_1.default.createElement("div", null,
                "\u062A\u0633\u0645\u064A\u0629 \u0627\u0644\u062A\u0635\u0646\u064A\u0641 ", category === null || category === void 0 ? void 0 :
                category.name),
            react_1.default.createElement("input", { onChange: e => setname(e.target.value) }),
            react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"))));
}
exports.default = CategoryEditor;
